import React from 'react';
import PropTypes from 'prop-types';
import { EditorBlockContainer } from './EditorBlockContainer';


export class EditorPageContainer extends React.Component {
  constructor(props) {
    super(props);
    this.blockContainers = [];
  }
  static propTypes = {
    blocks: PropTypes.array.isRequired,
    onBlockSync: PropTypes.func.isRequired,
    onBlockUpdate: PropTypes.func.isRequired,
    onElementDelete: PropTypes.func.isRequired,
    onInvokeGallery: PropTypes.func.isRequired,
    onInvokeIconChooser: PropTypes.func.isRequired,
    srcForMedia: PropTypes.func.isRequired,

    font: PropTypes.object.isRequired,
    color: PropTypes.object.isRequired,
  };

  getPageHtml = () => {
    const blockHtmlArray = this.blockContainers.map(item => item.getBlockHtml());
    return blockHtmlArray.join('\n');
  };

  render() {
    const { blocks, font, color } = this.props;
    const blockItems = blocks.map((block, index) => (
      <EditorBlockContainer
        ref={instance => { this.blockContainers[index] = instance; }}
        key={block.urlsafe}
        block={block}
        color={color}
        font={font}

        onBlockSync={(content, synctill) => this.props.onBlockSync(block.urlsafe, content, synctill)}
        onElementDelete={(address) => this.props.onElementDelete(block.urlsafe, address)}
        onBlockUpdate={(address, updatedProps) => this.props.onBlockUpdate(block.urlsafe, address, updatedProps)}
        onInvokeGallery={(address, selectedProp, renderSize) => this.props.onInvokeGallery(block.urlsafe, address, selectedProp, renderSize)}
        onInvokeIconChooser={(address, selectedProp) => this.props.onInvokeIconChooser(block.urlsafe, address, selectedProp)}
        srcForMedia={(mediaUrlsafe, renderSize)=> this.props.srcForMedia(mediaUrlsafe, renderSize)}
      />
    ));

    return (
      <React.Fragment>
        {blockItems}
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./scripts/components/editor/EditorPageContainer.jsx